/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type ServiceAdminSearchDevicesQueryVariables = Types.Exact<{
  searchTerm: Types.Scalars['String'];
  pageSize?: Types.InputMaybe<Types.Scalars['Int']>;
  pageNumber?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type ServiceAdminSearchDevicesQuery = { __typename: 'Query', serviceAdminSearchDevices: { __typename: 'ServiceAdminDeviceSearchPayload', totalCount: number, results: Array<{ __typename: 'ServiceAdminDeviceSearchResult', id: string, alias?: string | null, mac: string, serialNumber: string, connected: boolean, power?: Types.Power | null, customerName: string, organizationId: string, organizationName: string, accessState: Types.ServiceAdminGlobalSearchAccessState }> } };


export const ServiceAdminSearchDevicesDocument = gql`
    query ServiceAdminSearchDevices($searchTerm: String!, $pageSize: Int, $pageNumber: Int) {
  serviceAdminSearchDevices(
    searchTerm: $searchTerm
    pageSize: $pageSize
    pageNumber: $pageNumber
  ) {
    totalCount
    results {
      id
      alias
      mac
      serialNumber
      connected
      power
      customerName
      organizationId
      organizationName
      accessState
    }
  }
}
    `;

/**
 * __useServiceAdminSearchDevicesQuery__
 *
 * To run a query within a React component, call `useServiceAdminSearchDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceAdminSearchDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceAdminSearchDevicesQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      pageSize: // value for 'pageSize'
 *      pageNumber: // value for 'pageNumber'
 *   },
 * });
 */
export function useServiceAdminSearchDevicesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ServiceAdminSearchDevicesQuery, ServiceAdminSearchDevicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ServiceAdminSearchDevicesQuery, ServiceAdminSearchDevicesQueryVariables>(ServiceAdminSearchDevicesDocument, options);
      }
export function useServiceAdminSearchDevicesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ServiceAdminSearchDevicesQuery, ServiceAdminSearchDevicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ServiceAdminSearchDevicesQuery, ServiceAdminSearchDevicesQueryVariables>(ServiceAdminSearchDevicesDocument, options);
        }
export type ServiceAdminSearchDevicesQueryHookResult = ReturnType<typeof useServiceAdminSearchDevicesQuery>;
export type ServiceAdminSearchDevicesLazyQueryHookResult = ReturnType<typeof useServiceAdminSearchDevicesLazyQuery>;
export type ServiceAdminSearchDevicesQueryResult = ApolloReactCommon.QueryResult<ServiceAdminSearchDevicesQuery, ServiceAdminSearchDevicesQueryVariables>;